import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from '@edikk-edikk/helmet';
import { Breadcrumb } from '#baseBreadcrumbs/containers';

const MetaData: FC = () => {
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ defaultMessage: 'Forgot password' })}
        </title>
      </Helmet>
      <Breadcrumb
        id="forgotPassword"
        title={intl.formatMessage({ defaultMessage: 'Forgot password' })}
      />
    </>
  );
};

export { MetaData };
